import { atom } from "jotai";

// Flag indicating there's a pending recapture task (enable design services + scroll to textarea)
export const isRecaptureTaskPendingAtom = atom(false);
